import React, { useEffect, useState } from "react";
import { Box, InputLabel, TextField, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import CommonUtil from "../util/CommonUtils";

export default function PasswordField({ sx = {}, ...props }) {
  const [helperText, setHelperText] = useState(props.helperText);
  const [error, setError] = useState(props.error);
  const { t } = useTranslation();
  const isExtraLargeScreen = useMediaQuery("(min-width: 1561px)");

  useEffect(() => {
    setError(props.error);
    setHelperText(props.helperText);
  }, [props.error]);

  const preventHandleBlur = [
    props.blurField,
    "password",
    "confirmPassword",
    "oldPassword",
    "newPassword",
  ];

  const handleBlur = () => {
    if (!preventHandleBlur.includes(props.name)) {
      setHelperText("");
      setError(false);
    }
  };

  const handleChange = (e) => {
    if (props.regex === "none" && props.validation) {
      switch (props.validation) {
        case "password":
          handlePassword(e);
          break;
        default:
          props.handleChange(e);
      }
    }
  };

  const handlePassword = (e) => {
    props.handleChange(e);
    if (CommonUtil.isValidPassword(e.target.value)) {
      setHelperText(props.helperText);
      setError(false);
    } else {
      setError(true);
      setHelperText(t("Password length should be less than 64 characters"));
    }
  };

  const preventCopyPaste = (e) => {
    e.preventDefault();
  };

  return (
    <Box letiant="standard" style={{ width: "100%" }}>
      <InputLabel
        shrink
        htmlFor="bootstrap-input"
        style={{ paddingLeft: "0px", size: "large" }}
      >
        <Typography variant="fieldLabel"> {props.label} </Typography>
        {props.required ? <span style={{ color: "red" }}>*</span> : ""}
      </InputLabel>
      <TextField
        {...props}
        fullWidth
        size={isExtraLargeScreen ? "large" : props.size}
        sx={{
          "& .MuiOutlinedInput-input": {
            backgroundColor: "#fff !important",
          },
          "& .MuiOutlinedInput-root":{
            backgroundColor: "#fff !important",
          },
          ...sx}}
        onBlur={() => handleBlur()}
        value={props.value}
        helperText={helperText}
        label={""}
        error={error}
        onChange={(e) => {
          handleChange(e);
        }}
        onCopy={(e) => preventCopyPaste(e)}
        onPaste={(e) => preventCopyPaste(e)}
        onCut={(e) => preventCopyPaste(e)}
        onDragStart={(e) => preventCopyPaste(e)}
      />
    </Box>
  );
}

PasswordField.defaultProps = {
  validation: "none",
  regex: "none",
};
